import logo from './logo.svg';
import './App.css';
import Header from './components/Header';
import Hero from './pages/Home';
import FeatureSection from './pages/Services';
import Service from './pages/Services';
import About from './pages/About';
import Testimonials from './pages/Testimonials';
import WhyChooseUs from './pages/WhyChooseUs';
import Contact from './pages/Contact';

function App() {
  return (
    <div className="App">
     <Header/>
     <Hero/>
     <Service/>
     <About/>
     <Testimonials/>
     <WhyChooseUs/>
     <Contact/>
    </div>
  );
}

export default App;
